import img from '../../../img/drink1.svg'
import img2 from '../../../img/drink2.svg'
import img3 from '../../../img/drink3.svg'
import img4 from '../../../img/drink4.svg'
import img5 from '../../../img/drink5.svg'
import img6 from '../../../img/drink6.svg'


export const drinkData = [
    {
        img: img,
        name: 'Филадельфия кранч',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'drink#1'
    },
    {
        img: img2,
        name: 'Филадельфия крем-брюле',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'drink#2'
    },
    {
        img: img3,
        name: 'Супер Филадельфия',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'drink#3'
    },
    {
        img: img4,
        name: 'Тигр мама',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'drink#4'
    },
    {
        img: img5,
        name: 'Супер Филадельфия',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'drink#5'
    },
    {
        img: img6,
        name: 'Филадельфия кранч',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'drink#6'
    },
    {
        img: img,
        name: 'Супер Филадельфия',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'drink#7'
    },
    {
        img: img2,
        name: 'Тигр мама',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'drink#8'
    },
]